import { isEngineeringUser, useAuth } from "@assetwatch/auth";
import {
  AppShell,
  AppShellMobileNavigationTrigger,
  AssetWatchLogo,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  DEFAULT_PROFILE_MENU_LABELS,
  ProfileMenu,
  Sidebar,
  SidebarItem,
  TopBar,
  TopBarActions,
  TopBarContent,
  TopBarLeading,
} from "@assetwatch/ui";
import {
  createFileRoute,
  Link,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { setModalityRouteSentryContext } from "../lib/sentry";

function ModalityLayout() {
  const { signOut, user } = useAuth();
  const { t } = useTranslation();
  const pathname = useRouterState({
    select: (state) =>
      state.resolvedLocation?.pathname ?? state.location.pathname,
  });

  useEffect(() => {
    setModalityRouteSentryContext(pathname);
  }, [pathname]);

  return (
    <AppShell>
      <TopBar>
        <TopBarLeading>
          <AppShellMobileNavigationTrigger />
          <span className="max-[599px]:hidden">
            <AssetWatchLogo aria-label="AssetWatch" />
          </span>
        </TopBarLeading>
        <TopBarContent>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage>{t("common.home")}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </TopBarContent>
        <TopBarActions>
          <ProfileMenu
            engineeringOnly={isEngineeringUser(user)}
            labels={DEFAULT_PROFILE_MENU_LABELS}
            onSignOut={() => void signOut()}
          />
        </TopBarActions>
      </TopBar>
      <Sidebar mobileHeaderLeading={<AssetWatchLogo aria-label="AssetWatch" />}>
        <SidebarItem
          itemId="home"
          label={t("common.home")}
          leading={{ type: "icon", name: "home" }}
          render={<Link to="/" />}
          selected={pathname === "/"}
        />
        <SidebarItem
          itemId="motion-amplification"
          label={t("motionAmplification.pageTitle")}
          leading={{ type: "icon", name: "upload" }}
          render={<Link to="/motion-amplification" />}
          selected={pathname === "/motion-amplification"}
        />
      </Sidebar>
      <Outlet />
    </AppShell>
  );
}

export const Route = createFileRoute("/_app")({
  component: ModalityLayout,
});
